/**
 * 環境変数の型付き wrapper。
 * 必須変数が未設定の場合は起動時に例外を投げる。
 */
interface AppEnv {
  VITE_API_BASE_URL: string;
  VITE_APP_BASE_URL: string;
  VITE_COGNITO_DOMAIN: string;
  VITE_COGNITO_APP_CLIENT_ID: string;
  VITE_COGNITO_REGION: string;
}

function require_(key: keyof AppEnv): string {
  const value = import.meta.env[key];
  if (!value || typeof value !== 'string') {
    console.warn(`Environment variable ${key} is not set. Using empty string.`);
    return '';
  }
  return value;
}

export const env: AppEnv = {
  VITE_API_BASE_URL: require_('VITE_API_BASE_URL'),
  VITE_APP_BASE_URL: require_('VITE_APP_BASE_URL'),
  VITE_COGNITO_DOMAIN: require_('VITE_COGNITO_DOMAIN'),
  VITE_COGNITO_APP_CLIENT_ID: require_('VITE_COGNITO_APP_CLIENT_ID'),
  VITE_COGNITO_REGION: require_('VITE_COGNITO_REGION'),
};
